// extracted by mini-css-extract-plugin
module.exports = {"w1gkx8jz":"w1gkx8jz"};